import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import ThemeToggle from './ThemeToggle';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background/90 dark:bg-card/90 backdrop-blur-lg shadow-lg border-b border-border'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          
          {/* Logo */}
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img src="/logo.png" alt="العليمي" className="h-12 w-12" />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-800 dark:text-gray-100">
                العليمي
              </span>
              <span className="text-sm text-gray-600 dark:text-gray-400">
                لاستضافة المواقع
              </span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-700 dark:text-gray-200 hover:text-[#4A9FD8] transition-colors font-medium"
            >
              المميزات
            </button>

            <Button
              onClick={() => scrollToSection('hero')}
              className="bg-[#4A9FD8] hover:bg-[#3A8FC8] text-white px-6"
            >
              ابدأ الآن
            </Button>

            {/* Theme Toggle */}
            <ThemeToggle />
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 dark:text-gray-200"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white dark:bg-gray-900 rounded-lg shadow-xl mt-2 mb-4 p-4 animate-in slide-in-from-top duration-300">
            <nav className="flex flex-col gap-4 text-right">
              <button
                onClick={() => scrollToSection('features')}
                className="text-gray-700 dark:text-gray-200 hover:text-[#4A9FD8] transition-colors font-medium py-2"
              >
                المميزات
              </button>

              <Button
                onClick={() => scrollToSection('hero')}
                className="bg-[#4A9FD8] hover:bg-[#3A8FC8] text-white w-full"
              >
                ابدأ الآن
              </Button>

              {/* Theme Toggle (Mobile) */}
              <div className="flex justify-end">
                <ThemeToggle />
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
